<template>
  <div>
    <header id="blog-header">
      <div class="inner ">
        <slot name="headContent"></slot>
      </div>
    </header>
    <article class="post">
      <div class="inner">
        <p class="meta" >
          last update:
        <time :pubdate="shares.fields.last_edit_date" >{{$options.filters.date(shares.fields.last_edit_date, '%w')| toWeekDay}},</time>
        <time :pubdate="shares.fields.last_edit_date" :data-updated="shares.fields.last_edit_date"
              v-text="$options.filters.date(shares.fields.last_edit_date, '%b')+' '+
              $options.filters.date(shares.fields.last_edit_date, '%d')+ ','+
              $options.filters.date(shares.fields.last_edit_date, '%Y') + ' at '+
              $options.filters.date(shares.fields.last_edit_date, '%T')"
        >
        </time>
      </p>
        <section class="post-excerpt" >
          <span id="share-content" v-if='shares' v-html="shares.content "></span>
        </section>
      </div>
    </article>
  </div>

</template>

<script>
import appLayout from './layout/AppLayout'
export default {
  name: 'shares',
  components: {
    appLayout
  },
  data () {
    return {
      shares: null
    }
  },
  methods: {
    async getShares () {
      let share = this.$store.state.share;
      if(share !=null){
        this.shares = share;
        console.log("load shares cache")
      }else{
        let reqUrl = this.$store.state.baseUrl + '/blog/api/shares';
        // console.log(reqUrl)
        await this.$http.get(reqUrl)
          .then((response) => {
            var res = JSON.parse(response.bodyText);
            this.shares = res.shares;
            this.$store.commit('assignShare', res.shares);
            console.log(res)
          })
      }
    }
  },
  created () {
    this.getShares()
  }
}
</script>

<style scoped>

#share-content {
   font-size: 0.8em;
}
</style>



// WEBPACK FOOTER //
// src/views/Shares.vue